import React from "react";
import { t } from "i18next";
import { CHAT_APP } from "../../constants/constant";

const SendMessageView = (props) => {
  const { message, sendMessage, setMessage } = props;

  const onChange = (event) => {
    setMessage(event.target.value);
  };

  const onPressEnterKey = (event) => {
    if (CHAT_APP.ENTER === event.key) {
      sendMessage();
    }
  };

  return (
    <form>
      <div className="chat-message">
        <textarea
          name="message"
          className="form-control chat-text-area"
          rows="2"
          id="comment"
          placeholder={t("i_want_to")}
          onChange={(event) => onChange(event)}
          onKeyDown={(event) => onPressEnterKey(event)}
          value={message}
        ></textarea>
        <button
          className="btn btn-primary fixed m-2"
          type="button"
          disabled={message === "" ? true : false}
          onClick={() => sendMessage()}
        >
          {t("send")}
        </button>
      </div>
    </form>
  );
};

export default SendMessageView;
